<template>
  <form-wrapper>
    <b-form @submit="onSubmit">
      <h2 class="text-center">
        Create a new organization
      </h2>
      <b-form-group>
        <label for="name-input">Name</label>
        <input
          v-validate="'required|organizationName'"
          id="name-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length }"
          :value="fields.name"
          class="form-control"
          type="text"
          name="name"
          @input="setName"/>
        <validation-errors :validation-errors="[errors.first('name')]"/>
        <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          id="enable-bioreq"
          v-model="enablebioreq"
          name="enable-bioreq-checkbox"
          value="1"
          unchecked-value="0"
          @input="setEnableBioreq"
        >
          Enable Bioreq
        </b-form-checkbox>
      </b-form-group>

      <b-form-group class="form-buttons">
        <b-button :disabled="disabled" type="submit" variant="primary">
          Confirm
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>

      <form-success :success="success" class="form-alert">Organization Created!</form-success>
    </b-form>
  </form-wrapper>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import passwordRules from '../../../common/form/password-rules'
import validationErrors from '../../../common/form/validation-errors'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'

export default {
  components: {
    passwordRules,
    validationErrors,
    formSuccess,
    formWrapper
  },  
  data () {
    return {
      enablebioreq: 0
    }
  },
  computed: {
    ...mapState('tenants/forms/store', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.$store.commit('tenants/forms/store/resetFields')
      }
    }
  },
  methods: {
    ...mapActions({
      storeTenant: 'tenants/store'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.storeTenant()
        }
      })
    },
    setName (e) {
      this.$store.commit('tenants/forms/store/setField', {
        field: 'name',
        value: e.target.value
      })
    },
    setEnableBioreq () {
      alert(this.enablebioreq)
      this.$store.commit('tenants/forms/store/setField', {
        field: 'enableBioreq',
        value: this.enablebioreq
      })
    },
    resetForm (event) {
      this.errors.clear()
      this.$store.commit('tenants/forms/store/resetState')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/organizations/add.vue